import { render } from "./ChatDetailsLeftItem.vue?vue&type=template&id=2d6ed296&scoped=true"
import script from "./ChatDetailsLeftItem.vue?vue&type=script&lang=js"
export * from "./ChatDetailsLeftItem.vue?vue&type=script&lang=js"

import "./ChatDetailsLeftItem.vue?vue&type=style&index=0&id=2d6ed296&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6ed296"]])

export default __exports__